<template>
  <div class="container py-5">

    <p>
    <b> 🌍 國際醫美教育分享｜TSK 線上研討會 </b>
    <br>由 TSK 海外舉辦的國際線上研討會即將登場，邀請來自印尼與菲律賓的專業皮膚科醫師，分享醫美注射的基礎技巧與臨床經驗。
    <br><br><b>✨ Mastering Fundamental Techniques in Aesthetic Injectables</b><br>🔹 Dr. Stanley Setiawan, Sp.DVE, FINSDV, FAADV - Indonesian Dermatologist <br>🔹 Dr. Jonathan Nevin T. Yu, MD, FPDS, iFAAD - Filipino Dermatologist 

<br><br><b>✨What's the topic?</b><br>- Anatomical approaches to botulinum toxin injections, including facial assessment.<br>- Cannula injection techniques of subdermal hydration boosters on face & neck.


    <br><br>📅 日期：2026 年 4 月 8 日 (三)<br>🕖 時間：7:00 PM（JKT Time）<br>📍 線上平台：Zoom Live <a href="https://tinyurl.com/TSK-FD" target="_blank">
  （please find the link）
</a>
<br><br>🔹 本活動由 TSK 海外主辦，誠摯推薦給關注醫美注射技術的專業人士。<br>歡迎有興趣的醫師與業界夥伴踴躍參與！
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_60.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
